import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';
import { Utility } from '../_service/utility';
import { WindowScrollService } from '../_service/window.scroll.service';

@Directive({
  selector: '[lazy]'
})
export class LazyDirective {

  @Output() onScroll = new EventEmitter<boolean>();
  index = -1;
  constructor(
    private scroll: WindowScrollService,
    private elementRef: ElementRef,
    private _utility:Utility
  ) { }

  ngOnDestroy(): void {
    this.scroll.removeIndex(this.index);
    clearTimeout(this.timeout);
  }
  private timeout= null;
  ngAfterViewInit(): void {
   // console.log("lazy component")
    this.timeout = setTimeout(() => {
      let el = this.elementRef.nativeElement as HTMLElement;
      let rect = el.getBoundingClientRect();
      let posY =  (rect.y || rect.top);
      let scrollY = this._utility.getWindow().innerHeight + this._utility.getWindow().scrollY;
      if (scrollY > posY) {
        this.onScroll.emit(true);
      }
      else {
        this.index = this.scroll.addPlaceHolder(posY - scrollY, () => {
          this.index = -1;
          this.onScroll.emit(true);
        })
      }

    }, 200)

  }
}
